module.exports = __webpack_public_path__ + "img/5.c008ede6.svg";